import React from 'react'
import { dateFormatterUTC } from '@usap/core'
import Availability from './Availability'
import {
  StyledButton, StyledDate, StyledDeliveryDatesContainer, StyledText,
} from './DeliveryDatesWmo.css'

const DeliveryDatesWmo = ({
  ground, dataTestId, handleSeeAllDates, showPopup, shouldShowPopup, data,
}) => (
  <StyledDeliveryDatesContainer>
    <StyledText>
      {'Get it by '}
    </StyledText>
    <StyledDate>
      {dateFormatterUTC(ground.deliveryDate)}
      {' '}
    </StyledDate>
    <StyledButton
      type="button"
      data-testid={dataTestId}
      onClick={handleSeeAllDates}
    >
      See All Dates
    </StyledButton>
    <Availability
      data={data}
      showPopup={showPopup}
      shouldShowPopup={shouldShowPopup}
    />
  </StyledDeliveryDatesContainer>
)

export default DeliveryDatesWmo
